/**
 * Validates and cleans a Twitter username
 * @param {string} username - The Twitter username to validate
 * @returns {string} The cleaned username
 * @throws {Error} If username is invalid
 */
export const validateTwitterUsername = (username) => {
  // Remove @ if present
  let cleanUsername = username.trim().replace(/^@/, '');
  
  // Basic validation
  if (!cleanUsername) {
    throw new Error('Twitter username is required');
  }
  
  // Twitter username rules
  const usernameRegex = /^[A-Za-z0-9_]{1,15}$/;
  if (!usernameRegex.test(cleanUsername)) {
    throw new Error('Invalid Twitter username format');
  }
  
  return cleanUsername;
};

/**
 * Handles Twitter API errors
 * @param {Error} error - The error object from Twitter API
 * @returns {TwitterError} Formatted error object
 */
export const handleTwitterError = (error) => {
  return {
    message: error.message || 'An error occurred with Twitter',
    code: error.code
  };
};